export default "__VITE_ASSET__COCOW$YC__"